// extracted by mini-css-extract-plugin
export default {"rating":"hz-z","numberOfStars":"iz-z","count":"jz-z","barGraphSpacing":"kz-z","barGraph":"lz-z"};